import { EventTrackingClient } from '@truepill/emr-analytics'
import { ANALYTICS_CONFIG } from "src/constants"

enum ScreenType {
    MOBILE = 'Mobile',
    TABLET = 'Tablet',
    DESKTOP = 'Desktop'
}

export class AnalyticsUtils {
    static getScreenType() {
        const screen = navigator.userAgent
        const regexMobile = /Mobile|iPhone|IPod|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/

        const regexTablet = /(tablet|iPad|playbook|Silk)|(android(?!.*mobi))/i

        if (regexTablet.test(screen)) {
            return ScreenType.TABLET
        }

        if (regexMobile.test(screen)) {
            return ScreenType.MOBILE
        }

        return ScreenType.DESKTOP
    }
}

const analyticsTrackingClient = () => {
    return new EventTrackingClient(ANALYTICS_CONFIG)
}
const analyticsTracker = analyticsTrackingClient()

export default analyticsTracker
